module.exports = __webpack_public_path__ + "8b788f760b02bc925c40e6b9483f0a9d.svg";